'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// src: https://stackoverflow.com/questions/33855641/copy-output-of-a-javascript-variable-to-the-clipboard
function copyToClipboard(text) {
    var dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
}

exports.default = copyToClipboard;
//# sourceMappingURL=copy_to_clipboard.js.map
